import React, { useState } from "react";
import "./timetable-client.scss";
import { Redirect } from "react-router";

const TimetableClient = (props) => {
  const { schedule, child } = props;
  const [trainingId, setTrainingId] = useState(null);

  const styleDay = (day) => {
    if (day === "Сегодня") {
      return { color: "#81CC5E" };
    } else return { color: "#4594CC" };
  };

  if (trainingId !== null) {
    return (
      <Redirect
        to={{
          pathname: `/client/training/${trainingId}`,
          state: { child_id: props.child_id, child: child },
        }}
      />
    );
  }

  return (
    <div className="timetableWrapper">
      {schedule.map((item) => (
        <div
          className="timetableContainer"
          key={item.id}
          onClick={() => setTrainingId(item.id)}
        >
          <div className="timetableHeader">
            <h2 style={styleDay(item.dataString)}>{item.dataString}</h2>
            <div className="timetableHeaderDate">
              <label>
                {item.startTime}-{item.endTime}
              </label>
              <label>{item.day}</label>
            </div>
          </div>
          <div className="timetableContent">
            <h3>{item.group.name}</h3>
            <label>{item?.filial?.address}</label>
          </div>
          <div className="timetableFooter">
            <span>
              Тренер {item.trainer.first_name} {item.trainer.last_name}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TimetableClient;
